import { useLocation } from "@tanstack/react-router"
import { useMemo } from "react"

export function useSearchParams() {
  const location = useLocation()

  return useMemo(() => {
    return new URLSearchParams(location.search)
  }, [location.search])
}
